export default {"src":"/_next/static/media/404.9ddc6341.gif","height":370,"width":669,"blurWidth":0,"blurHeight":0};